import finmetrixColors from '../helpers/finmetrix-colors'

const $ = kendo.jQuery

function renderChart($container, options, renderLocation) {
  return new Promise(function(resolve, reject) {
    const actionName = renderLocation === 'report' ? 'DataSource' : 'DataSourceComponent'
    const chart = $('<div></div>').appendTo($container)
    const controllerName = 'ExposureReport'
    const dataSourceUrl = `/api/report/${controllerName}/${actionName}`

    $.ajax({
      url: dataSourceUrl,
      data: options,
      success: function(response) {
        const data = response.data.filter(el => el.Period != 'Grand Total')
        const {
          typeNumCols,
          minRateValue,
          fromDate,
          periodEndDate,
          clientName,
          reportTitle,
          priceText,
          unitText,
        } = response

        buildExposureChart(
          chart,
          data,
          typeNumCols,
          minRateValue,
          periodEndDate,
          fromDate,
          clientName,
          renderLocation,
          reportTitle,
          priceText,
          unitText,
        )
          .then(function(eChart) {
            resolve(eChart)
          })
          .catch(err => reject(err))
      },
      error: function(error) {
        reject(error)
      },
    })
  })
}

function buildExposureChart(
  element,
  data,
  typeNumCols,
  minRateValue,
  periodEndDate,
  fromDate,
  clientName,
  renderLocation,
  reportTitle,
  priceText,
  unitText,
) {
  return new Promise(function(resolve) {
    const pdf = renderLocation === 'dashboard'
    const parsedDate = kendo.toString(kendo.parseDate(periodEndDate), 'MMMM-yyyy')
    const text = !pdf
      ? `${reportTitle}
         ${clientName} - ${parsedDate}`
      : ' '

    const getTypeNumName = id => {
      const col = typeNumCols.find(el => el.typeNumId === id)
      return col ? col.typeNumName : ''
    }
    const getTypeNumVisible = id => {
      const col = typeNumCols.find(el => el.typeNumId === id)
      return col ? col.visible : false
    }

    const risqueNetText = getTypeNumName(4)

    const couvertureText = getTypeNumName(7)

    const niveauText = getTypeNumName(8)

    const couvertureDesireeText = getTypeNumName(9)

    const adjustmentText = getTypeNumName(21)

    const tauxBudgetText = getTypeNumName(22)

    const tauxMarcheText = getTypeNumName(23)

    const niveauNCText = getTypeNumName(43)
    const niveauNCVisible = getTypeNumVisible(43)

    $(element)
      .kendoChart({
        renderAs: pdf ? 'canvas' : 'svg',
        transitions: !pdf,
        title: {
          text: text,
          padding: {
            bottom: 5,
          },
        },
        legend: {
          position: 'bottom',
          item: {
            visual: makeVisualLegend,
          },
        },
        dataSource: data,
        seriesDefaults: {
          type: 'column',
        },
        series: [
          {
            field: 'RisqueNet',
            name: risqueNetText,
            color: finmetrixColors.Green,
            labels: {
              visible: false,
            },
          },
          {
            field: 'Couverture',
            name: couvertureText,
            color: finmetrixColors.Blue,
            labels: {
              visible: false,
            },
          },
          {
            field: 'Adjustment',
            name: adjustmentText,
            color: finmetrixColors.Red,
            tooltip: {
              visible: true,
              background: '#f00',
            },

            labels: {
              visible: false,
            },
          },
          {
            field: 'Couverture_Desiree',
            name: couvertureDesireeText,
            color: 'rgba(255,255,255, 0.0001)',
            type: 'line',
            tooltip: {
              visible: true,
              format: '{0:N0}',
              background: '#d3d0ce',
            },
            highlight: {
              toggle: function(e) {
                e.preventDefault()
                var visual = e.visual
                var transform = null
                if (e.show) {
                  var center = visual.rect().center()
                  transform = kendo.geometry.transform().scale(1.5, 1.5, center)
                }
                visual.transform(transform)
              },
            },
            markers: {
              size: 14,
              visual: function(e) {
                const src = '/img/markers/line.png'
                return new kendo.drawing.Image(src, e.rect)
              },
            },
          },
          {
            field: 'ActualRate',
            name: tauxMarcheText,
            color: finmetrixColors.LightBlue,
            type: 'line',
            markers: {
              size: 3,
              visible: false,
            },
            format: '{0:N4}',
            axis: 'rateAxis',
            tooltip: {
              visible: true,
              format: '{0:N4}',
            },
          },
          {
            field: 'BudgetRate',
            name: tauxBudgetText,
            color: finmetrixColors.Blue,
            type: 'line',
            markers: {
              size: 3,
              visible: false,
            },
            format: '{0:N4}',
            axis: 'rateAxis',
            tooltip: {
              visible: true,
              format: '{0:N4}',
            },
          },
          {
            field: 'Niveau',
            name: niveauText,
            color: 'rgba(255,255,255, 0.0002)',
            type: 'line',
            format: '{0:N4}',
            axis: 'rateAxis',
            tooltip: {
              visible: true,
              format: '{0:N4}',
              background: '#1a345c',
            },
            highlight: {
              toggle: function(e) {
                e.preventDefault()
                var visual = e.visual
                var transform = null
                if (e.show) {
                  var center = visual.rect().center()
                  transform = kendo.geometry.transform().scale(1.5, 1.5, center)
                }
                visual.transform(transform)
              },
            },
            markers: {
              size: 14,
              visual: function(e) {
                const src = '/img/markers/diamond.png'
                return new kendo.drawing.Image(src, e.rect)
              },
            },
          },
          niveauNCVisible
            ? {
                field: 'NiveauNC',
                name: niveauNCText,
                color: 'rgba(255,255,255, 0.0003)',
                type: 'line',
                format: '{0:N4}',
                axis: 'rateAxis',
                tooltip: {
                  visible: true,
                  format: '{0:N4}',
                  background: '#1a345c',
                },
                highlight: {
                  toggle: function(e) {
                    e.preventDefault()
                    var visual = e.visual
                    var transform = null
                    if (e.show) {
                      var center = visual.rect().center()
                      transform = kendo.geometry.transform().scale(1.5, 1.5, center)
                    }
                    visual.transform(transform)
                  },
                },
                markers: {
                  size: 14,
                  visual: function(e) {
                    const src = '/img/markers/circle.png'
                    return new kendo.drawing.Image(src, e.rect)
                  },
                },
              }
            : {},
        ],
        valueAxes: [
          {
            labels: {
              format: '{0:N0}',
              font: '10px Arial',
            },
            title: {
              text: unitText,
              font: '12px Arial',
              position: 'top',
              rotation: 0,
              margin: {
                top: -32,
              },
            },
          },
          {
            name: 'rateAxis',
            min: minRateValue,
            labels: {
              format: '{0:N4}',
              font: '10px Arial',
            },
            title: {
              text: priceText,
              font: '12px Arial',
              position: 'top',
              rotation: 0,
              margin: {
                top: -32,
                left: -32,
              },
            },
          },
        ],
        categoryAxis: {
          field: 'Period',
          labels: {
            visible: true,
            rotation: -90,
            font: '11px Arial',
            background: 'transparent',
            padding: {
              top: 14,
            },
          },
          axisCrossingValues: [0, 500],
        },
        tooltip: {
          visible: true,
          format: '{0:N0}',
        },
        render: function(e) {
          if (renderLocation === 'dashboard') {
            var items = e.sender.dataSource.data().length
            if (items == 0) {
              e.sender.element.closest('.component').remove()
            }
          }
          resolve(element.getKendoChart())
        },
      })
      .data('kendoChart')
  })
}

function makeVisualLegend(e) {
  var color = e.options.markers.background
  var labelColor = e.options.labels.color
  var imageSrc = ''
  if (color === 'rgba(255,255,255, 0.0001)') {
    color = finmetrixColors.LightGray
    imageSrc = '/img/markers/line.png'
  } else if (color === 'rgba(255,255,255, 0.0002)') {
    color = finmetrixColors.Blue
    imageSrc = '/img/markers/diamond.png'
  } else if (color === 'rgba(255,255,255, 0.0003)') {
    color = finmetrixColors.Blue
    imageSrc = '/img/markers/circle.png'
  }
  var rectContainer = new kendo.geometry.Rect([0, 0], ['100%', 50])
  var layout = new kendo.drawing.Layout(rectContainer, {
    spacing: 3,
    alignItems: 'center',
  })
  var label = new kendo.drawing.Text(e.series.name + ' ', [10, 0], {
    fill: {
      color: labelColor,
    },
    font: '9px Arial',
  })
  var marker, rectGeometry

  if (imageSrc === '') {
    rectGeometry = new kendo.geometry.Rect([0, 0], [10, 3])
    marker = new kendo.drawing.Rect(rectGeometry).stroke(labelColor, 0).fill(color)
  } else {
    rectGeometry = new kendo.geometry.Rect([0, -6], [10, 10])
    marker = new kendo.drawing.Image(imageSrc, rectGeometry)
  }
  layout.append(marker, label)
  layout.reflow()
  return layout
}

export default {
  render: function($container, options, location = 'dashboard') {
    return renderChart($container, options, location)
  },
}
